import React, { useState } from 'react'
import { Link, usePage } from '@inertiajs/react'
import AccountSwitcher from '../../Components/AccountSwitcher'
import Avatar from '../../Components/Avatar'
import ProfileModals from '../../Components/ProfileModals'

export default function Layout({
  account,
  accounts,
  navigation,
  children,
  title,
  user
}) {
  const { url, props } = usePage()
  const is_admin = props.is_admin
  const currentUser = user || props.user
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [showProfile, setShowProfile] = useState(false)

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-30 w-64 bg-sky-900 transform transition-transform duration-200 ease-in-out
        lg:translate-x-0
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex flex-col h-full">
          {/* Logo/Brand */}
          <div className="flex items-center justify-between h-16 px-4 bg-sky-950">
            <span className="text-xl font-bold text-white">Manager</span>
            <button
              className="lg:hidden text-white"
              onClick={() => setSidebarOpen(false)}
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
            {navigation.map((item) => {
              const isActive = url === item.href ||
                (item.href !== '/manage' && url.startsWith(item.href))

              return (
                <Link
                  key={item.name}
                  href={item.href}
                  className={`
                    flex items-center px-3 py-2 text-sm font-medium rounded-md transition
                    ${isActive
                      ? 'bg-sky-800 text-white'
                      : 'text-sky-100 hover:bg-sky-800 hover:text-white'
                    }
                  `}
                >
                  {item.name}
                </Link>
              )
            })}
          </nav>

          {/* Admin Panel Link - only for admins */}
          {is_admin && (
            <div className="p-4 border-t border-sky-800">
              <a
                href="/aj/admin"
                className="flex items-center px-3 py-2 text-sm font-medium text-sky-100 rounded-md hover:bg-sky-800 hover:text-white transition"
              >
                Admin Panel
              </a>
            </div>
          )}

          {/* Kitchen Link */}
          <div className="p-4 border-t border-sky-800">
            <Link
              href="/kitchen"
              className="flex items-center px-3 py-2 text-sm font-medium text-sky-100 rounded-md hover:bg-sky-800 hover:text-white transition"
            >
              Open Kitchen Display
            </Link>
          </div>

          {/* Build version */}
          <div className="px-4 pb-3">
            <span className="text-xs text-sky-600">{props.build_version || 'dev'}</span>
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div className="lg:pl-64">
        {/* Top header */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center">
              {/* Mobile menu button */}
              <button
                className="lg:hidden mr-4 text-gray-500 hover:text-gray-700"
                onClick={() => setSidebarOpen(true)}
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>

              {title && (
                <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
              )}
            </div>

            <div className="flex items-center gap-4">
              <AccountSwitcher
                account={account}
                accounts={accounts}
                baseUrl="/manage"
              />
              {currentUser && (
                <Avatar
                  initials={currentUser.initials}
                  onClick={() => setShowProfile(true)}
                />
              )}
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8">
          {children}
        </main>
      </div>

      <ProfileModals
        user={currentUser}
        basePath="/manage"
        isOpen={showProfile}
        onClose={() => setShowProfile(false)}
      />
    </div>
  )
}
